'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useState } from 'react';
import { getInterruptAction } from './applyOutcome';
import { FUNNEL_INTERRUPTS } from './config';
import { dismissInterrupt } from './dismissed';
import type { InterruptId, InterruptPending } from './types';
type InterruptContextValue = {
  activeInterruptId: InterruptId | null;
  beginInterrupt: (id: InterruptId, pending: InterruptPending) => void;
  runAction: (actionId: string) => void;
};
const InterruptContext = createContext<InterruptContextValue | undefined>(undefined);
export function InterruptProvider(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const [activeInterruptId, setActiveInterruptId] = useState(null);
  const [pending, setPending] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (id, nextPending) => {
      setPending(nextPending);
      setActiveInterruptId(id);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const beginInterrupt = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setActiveInterruptId(null);
      setPending(null);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const clear = t2;
  let t3;
  if ($[2] !== activeInterruptId || $[3] !== pending) {
    t3 = actionId => {
      if (!activeInterruptId || !pending) {
        return;
      }
      const action = getInterruptAction(activeInterruptId, actionId, FUNNEL_INTERRUPTS);
      if (!action) {
        return;
      }
      const {
        resume,
        applyOutcome
      } = pending;
      if (action.outcome.kind === "continue") {
        dismissInterrupt(activeInterruptId);
        clear();
        resume();
        return;
      }
      clear();
      applyOutcome(action.outcome);
    };
    $[2] = activeInterruptId;
    $[3] = pending;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const runAction = t3;
  let t4;
  if ($[5] !== activeInterruptId || $[6] !== runAction) {
    t4 = {
      activeInterruptId,
      beginInterrupt,
      runAction
    };
    $[5] = activeInterruptId;
    $[6] = runAction;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== t4) {
    t5 = <InterruptContext.Provider value={t4}>{children}</InterruptContext.Provider>;
    $[8] = children;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export function useFunnelInterrupt() {
  const ctx = useContext(InterruptContext);
  if (!ctx) {
    throw new Error("useFunnelInterrupt must be used within InterruptProvider");
  }
  return ctx;
}